import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Container from '../../../Container/Container';
import ResponsibleGamingTimeLimits from '../../../ResponsibleGamingTimeLimits/ResponsibleGamingTimeLimits';

import {
  TXTWCL_Playing_Time_Limits,
  TXTWCL_Responsible_Gaming_Limits,
  TXTWCL_This_controls_how_long_you_pla_ELL
} from './RMFPlayingTimeLimit.messages.json';

const RMFPlayingTimeLimit: React.FC = () => {
  const siteId = useSelector(select.cms.getSiteId);
  const isGR = siteId === Sites.GR;
  return (
    <Container
      page={RMFPlayingTimeLimit}
      headerProps={{
        title: isGR ? (
          <Translation {...TXTWCL_Responsible_Gaming_Limits} />
        ) : (
          <Translation {...TXTWCL_Playing_Time_Limits} />
        ),
        buttons: {
          back: true
        }
      }}
      pageTopTitle={<Translation {...TXTWCL_Playing_Time_Limits} />}
      pageTopSubtitle={<Translation {...TXTWCL_This_controls_how_long_you_pla_ELL} />}
    >
      <ResponsibleGamingTimeLimits fieldName="rmf.playTime" />
    </Container>
  );
};

RMFPlayingTimeLimit.displayName = 'RMFPlayingTimeLimit';

export default RMFPlayingTimeLimit;
